import React from "react";
import { Map, Set } from "immutable";

import Add from "../../Add";
import uuid from "./uuid";
import PropertyInstanceFactory from "./PropertyInstanceFactory";

/**
 * Display a Schema.org property element.
 *
 * @since 1.0.0
 */
class Property extends React.Component {
  constructor(props) {
    super(props);

    // Bind functions.
    this.handleAdd = this.handleAdd.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.propertyInstanceDecorator = props.propertyInstanceDecorator;

    // Set the initial state to an empty ordered map of properties.
    this.state = {
      components: Map(
        Set(props.values).map(({ type, value: defaultValue }) => [
          uuid(),
          {
            component: this.propertyInstanceDecorator(
              PropertyInstanceFactory(props.property, type)
            ),
            type,
            defaultValue
          }
        ])
      ).toOrderedMap()
    };
  }

  handleAdd(property, range) {
    this.setState(prevState => ({
      components: prevState.components.set(
        // We use the `uuid` to uniquely identify a property for removal purposes.
        uuid(),
        // Use the `PropertyElementFactory` to create a property.
        {
          component: this.propertyInstanceDecorator(
            PropertyInstanceFactory(property, range.name)
          ),
          type: range.name
        }
      )
    }));
  }

  handleRemove(key) {
    this.setState(prevState => ({
      components: prevState.components.delete(key)
    }));
  }

  render() {
    const { property } = this.props;
    const { components } = this.state;
    return (
      <div>
        <strong>{property.name}</strong>
        <Add property={property} onAdd={this.handleAdd} />
        {components
          // The `key` is the `uuid`.
          .map(({ component: Component, ...props }, key) => (
            <Component
              key={key}
              property={property}
              onClick={() => this.handleRemove(key)}
              {...props}
            />
          ))
          .valueSeq()}
        {/*<div>{property.description}</div>*/}
        <hr style={{ color: "#007aff", width: "100%", height: "1px" }} />
      </div>
    );
  }
}

export default Property;
